
import React, { Component } from "react";
import iconFind from "../../../assets/images/icons/globe.png";

export interface IconGlobeProps
{
}

interface IconGlobeState 
{
}

export class IconGlobe extends Component<IconGlobeProps, IconGlobeState>
{
    constructor(props: IconGlobeProps)
    {
        super(props);

        this.state = {
        };
    }

    public render(): JSX.Element
    {
        return (
            <div className="icon">
                <img src={iconFind} alt="globe" style={{ maxWidth: "100%" }} />
            </div>
        );
    }
}